import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VMenu, {
    ref: "vueDatePicker",
    attrs: {
      "close-on-content-click": false,
      "return-value": _vm.pickerDate,
      "transition": "scale-transition",
      "offset-x": "",
      "min-width": "290px"
    },
    on: {
      "update:returnValue": function ($event) {
        _vm.pickerDate = $event;
      },
      "update:return-value": function ($event) {
        _vm.pickerDate = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function ({
        on
      }) {
        return [_c(VTextField, _vm._g({
          attrs: {
            "label": _vm.label,
            "value": _vm.value,
            "outlined": _vm.inpOutlined,
            "filled": _vm.inpFilled,
            "autocomplete": "off",
            "rules": _vm.rules
          },
          on: {
            "change": _vm.handleDateChanged
          }
        }, on))];
      }
    }]),
    model: {
      value: _vm.showPickerDialog,
      callback: function ($$v) {
        _vm.showPickerDialog = $$v;
      },
      expression: "showPickerDialog"
    }
  }, [_c(VDatePicker, {
    attrs: {
      "color": _vm.color,
      "first-day-of-week": _vm.firstDayOfWeek,
      "allowed-dates": _vm.allowedDates,
      "show-current": "",
      "no-title": ""
    },
    on: {
      "change": _vm.handleDateSelected,
      "input": function ($event) {
        _vm.showPickerDialog = false;
      }
    },
    model: {
      value: _vm.pickerDate,
      callback: function ($$v) {
        _vm.pickerDate = $$v;
      },
      expression: "pickerDate"
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };